export function TooltipProvider({ children }) {
  return children;
}

export function PageTooltip() {
  return null;
}

export function useTooltips() {
  return { dismissed: {}, dismiss: () => {}, dismissAll: () => {} };
}
